import { AutocompleteInput, Create, CreateButton, Datagrid, 
    DateField, DateInput, Edit, EditButton, ExportButton, List, 
    ReferenceField, ReferenceInput, SelectInput, SimpleForm, TextField,
    TextInput, TopToolbar, useNotify, useRedirect } from "react-admin";
import { ItasSearchAllFilter } from "./util/ItasSearchAllFilter";
import { CustomState } from "./ImpiantiReferenceProdotti";
import { ItasEditActions } from "./util/ItasEditActions";
import { ItasToolbar } from "./util/ItasToolbar";
import { CustomPagination, choices } from "./util/generic";

const ListActions = () => (
    <TopToolbar>
        <CreateButton label="Crea nuovo prodotto"/>
        <ExportButton label="Esporta dati" maxResults={10000}/>
    </TopToolbar>
  );
export const ProdottiCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Prodotto aggiunto`, { type: 'success' });
        redirect(`/prodotti`);
    };
    return (
        <Create 
        mutationOptions={{ onSuccess }}
        title="Aggiungi nuovo prodotto">
        <ItasEditActions />
        <ProdottiForm />
        </Create>
    );
}
export const ProdottiForm = () => {
    return (
        <SimpleForm 
        mode="onBlur" 
        reValidateMode="onBlur"
        toolbar={<ItasToolbar />}>
        <ReferenceInput source="id_impianto" reference="impianti" >
            <AutocompleteInput label="Impianto associato" optionText="descrizione" fullWidth/>
        </ReferenceInput>
        
        <SelectInput source="stato" choices={choices} optionText="state" optionValue="_id" defaultValue={1}/>
        <TextInput source="marca"       fullWidth />
        <TextInput source="modello"     fullWidth />
        <TextInput source="potenza"     fullWidth />
        <TextInput source="numero_serie"     fullWidth />
        <DateInput source="data_accensione" />
        <TextInput source="note"        fullWidth />
        </SimpleForm>
    )
}

export const ProdottiEdit = () => {
    const notify = useNotify();

    function notyifyAndRedirect (action) {
        notify(`Prodotto ${action}!`, { type: 'success' });
        window.history.go(-1)
    }

    const onSuccess = (data) => {
        notyifyAndRedirect("aggiornato")
    };
    const onDelete = (data) => {
        notyifyAndRedirect("eliminato")
    };
    return (
        <Edit mutationOptions={{ onSuccess, onDelete }}
            actions={<ItasEditActions />}
            mutationMode="optimistic"
            title="Modifica dettagli prodotto"
            >
            <ProdottiForm />
        </Edit>
    );
}

export const ProdottiList = () => (
    <List 
        filters={ItasSearchAllFilter} 
        perPage={12}
        actions={<ListActions />}    
        pagination={<CustomPagination />}

    >
        <Datagrid>
            
            <ReferenceField label="Impianto" source="id_impianto" reference="impianti">
                <TextField label="Impianto" source="descrizione" />
            </ReferenceField>
            {/* quando avrai fatto l'sql per la ricerca del giusto prodotto id allora possiamo 
                andare ad inserire il seguente codice
                <ReferenceField label="Prodotto" source="id_prodotto" reference="prodotti">
                    <TextField source="marca" />
                </ReferenceField>
            */}
            <CustomState source="stato" />
            <TextField source="marca" />
            <TextField source="modello" />
            <TextField source="numero_serie" />
            <DateField source="data_accensione" />
            <TextField source="potenza" />
            <TextField source="note" />
            
            <EditButton label="" />
        </Datagrid>
    </List>

);